import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { PermissionWrapper } from "../../helpers/permission.js";

const MediaUploadList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterName, setFilterName] = useState("");
  const token = localStorage.getItem("authToken");

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}media-upload`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          name: filterName
        }
      });
      if (response.data.status) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this media?")) return;
    try {
      const response = await axios.delete(`${API_URL}media-upload/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.status) {
        fetchData();
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filterName]);

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="row pb-2">
          <div className="col-md-6">
            <h4 className="panel-title pull-left">Manage Media Uploads</h4>
          </div>
          <div className="col-md-6" style={{ textAlign: "right" }}>
            <PermissionWrapper module="settings_media_upload" action="add">
              <Link
                to={"/Settings/MediaUpload/add"}
                className="btn btn-default btn-sm"
              >
                <FontAwesomeIcon icon={faPlus} /> Add Media Upload
              </Link>
            </PermissionWrapper>
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
            <div className="panel-heading border-0">
              <h4 className="panel-title m-0">Media Upload List</h4>
            </div>
            <div className="d-flex">
              <input
                type="text"
                className="form-control input-sm me-2"
                placeholder="Filter by Name"
                value={filterName}
                onChange={(e) => setFilterName(e.target.value)}
                style={{ width: "200px" }}
              />
            </div>
          </div>
          
          <div className="table-responsive">
            <table className="table m-b-0">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>#</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Path</th>
                  <th>Created On</th>
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>Loading...</td>
                  </tr>
                ) : data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={item.id}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td>
                        <a href={item.image_url} target="_blank" rel="noopener noreferrer">
                          View Image
                        </a>
                      </td>
                      <td>{item.name}</td>
                      <td>{item.path}</td>
                      <td>{new Date(item.created_on).toLocaleString()}</td>
                      <td style={{ textAlign: "center" }}>
                        <PermissionWrapper module="settings_media_upload" action="edit">
                          <Link
                            to={`/Settings/MediaUpload/edit/${item.id}`}
                            className="btn btn-xs btn-primary"
                            style={{ marginRight: '5px' }}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </Link>
                        </PermissionWrapper>
                        <PermissionWrapper module="settings_media_upload" action="delete">
                          <button
                            className="btn btn-xs btn-danger"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </PermissionWrapper>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaUploadList;
